import React from "react";
import { HiOutlineDocumentText } from "react-icons/hi";

import StoreIconSide from "../Common/svg/storeiconside";
import PhoneIcon from "../Common/svg/phoneicon";
import LocationSvg from "../Common/svg/locationGray";
import StoreActionHistory from "./StoreActionHistory";
import { formatPrice } from "../../utils/formatPrice";

const MultiStoreOrder = ({ orderData }) => {
  const order = orderData?.data?.order;
  const children = order?.children || [];

  console.log("order", orderData);

  return order?.is_multistore ? (
    <div className="card shadow-sm border-0 rounded-4">
      <div className="card-body p-4">
        {/* Header */}
        <div className="d-flex align-items-center mb-4">
          <HiOutlineDocumentText className="text-success me-2 fs-4" />
          <h6 className="mb-0 fw-bold text-dark">عناصر الطلب المتعدد</h6>
          <span className="badge bg-secondary ms-2">
            {children.length} متاجر
          </span>
        </div>

        {/* Multi-store cards */}
        <div className="multi-store-container">
          {children.map((childOrder, index) => (
            <div key={childOrder.id || index} className="mb-4">
              {/* Store Information */}
              <div className="store-info-card border rounded-3 p-3 mb-3 bg-light">
                <div className="d-flex align-items-center gap-3">
                  {childOrder.store?.logo && (
                    <img
                      src={childOrder.store.logo}
                      alt={childOrder.store.name}
                      className="store-logo rounded"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                  <div className="flex-grow-1">
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <div className="text-green">
                        <StoreIconSide />
                      </div>
                      <h6 className="text-smoke font16 font700 mb-0">
                        {childOrder.store?.name || "متجر غير محدد"}
                      </h6>
                      {childOrder.store?.id && (
                        <span className="badge bg-secondary ms-2">
                          رقم: {childOrder.store.id}
                        </span>
                      )}
                    </div>
                    <div className="d-flex flex-wrap gap-3 text-muted small">
                      {childOrder.store?.phone && (
                        <div className="d-flex align-items-center gap-1">
                          <PhoneIcon /> <span>{childOrder.store.phone}</span>
                        </div>
                      )}
                      {childOrder.store?.address && (
                        <div className="d-flex align-items-center gap-1">
                          <LocationSvg />{" "}
                          <span>{childOrder.store.address}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="text-end">
                    <div className="fw-bold text-success">
                      {childOrder.pricing?.final_amount /
                        childOrder.pricing?.currency_factor || 0}{" "}
                      {childOrder.pricing?.symbol_currency}
                    </div>
                    <div className="text-muted small">إجمالي المتجر</div>
                  </div>
                </div>
              </div>

              {/* Store Items */}
              <div className="table-responsive border rounded-3">
                <table className="table mb-0 align-middle">
                  <thead className="bg-light text-muted small">
                    <tr>
                      <th className="ps-4 fw-normal border-0">المنتج</th>
                      <th className="text-center fw-normal border-0">الكمية</th>
                      <th className="text-center fw-normal border-0">السعر</th>
                      <th className="text-center fw-normal border-0">الحالة</th>
                    </tr>
                  </thead>
                  <tbody>
                    {childOrder.items && childOrder.items.length > 0 ? (
                      childOrder.items.map((item, itemIndex) => (
                        <tr
                          key={item.id || itemIndex}
                          className={
                            item.status === "out_of_stock"
                              ? "row-out-of-stock"
                              : ""
                          }
                        >
                          <td
                            className={`ps-4 fw-bold ${item.action_status === "replaced" ? "text-warning" : item.action_status === "refunded" ? "text-danger" : "text-dark"} border-bottom-light`}
                          >
                            {item.product?.name || item.name} (
                            {item.action_status === "replaced"
                              ? "تم استبداله"
                              : item.action_status === "refunded"
                                ? "تم استرداده"
                                : " "}
                            )
                          </td>
                          <td className="text-center text-muted border-bottom-light">
                            {item.quantity || 1}
                          </td>
                          <td className="text-center text-muted border-bottom-light">
                            {item.total_price
                              ? `${item.total_price / item?.currency_factor || 0} ${childOrder.pricing?.symbol_currency || "SYP"}`
                              : "غير محدد"}
                          </td>
                          <td className="text-center">
                            {item.action_status === "replaced" ? (
                              <span className="badge bg-warning text-white">
                                تم استبداله
                              </span>
                            ) : item.action_status === "refunded" ? (
                              <span className="badge bg-danger text-white">
                                تم استرداده
                              </span>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-muted py-4">
                          لا توجد عناصر في هذا المتجر
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot>
                    <tr className="bg-light bg-opacity-50">
                      <td className="ps-4 fw-bold py-3" colSpan="2">
                        إجمالي المتجر
                      </td>
                      <td className="text-end pe-4 fw-bold py-3" colSpan="2">
                        {formatPrice(
                          childOrder.pricing?.currency_factor,
                          childOrder.pricing?.total_amount,
                        )}{" "}
                        {childOrder.pricing?.symbol_currency}
                      </td>
                    </tr>
                    <tr className="bg-light bg-opacity-50">
                      <td
                        className="ps-4 fw-bold text-success py-3"
                        colSpan="2"
                      >
                        الإجمالي النهائي{" "}
                      </td>
                      <td
                        className="text-success text-end pe-4 fw-bold py-3"
                        colSpan="2"
                      >
                        {formatPrice(
                          childOrder.pricing?.currency_factor,
                          childOrder.pricing?.final_amount,
                        )}{" "}
                        {childOrder.pricing?.symbol_currency}
                      </td>
                    </tr>
                    {childOrder.pricing && (
                      <tr className="bg-light bg-opacity-25">
                        <td className="ps-4 text-muted small" colSpan="2">
                          تفاصيل المتجر
                        </td>
                        <td
                          className="text-end pe-4 text-muted small"
                          colSpan="2"
                        >
                          <div>
                            الخصم:{" "}
                            {childOrder.pricing.discount_amount /
                              childOrder.pricing?.currency_factor || 0}{" "}
                            {childOrder.pricing?.symbol_currency}
                          </div>
                          <div>
                            رسوم التوصيل:{" "}
                            {childOrder.pricing.delivery_fee /
                              childOrder.pricing?.currency_factor || 0}{" "}
                            {childOrder.pricing?.symbol_currency}
                          </div>
                          <div>
                            الضريبة:{" "}
                            {childOrder.pricing.tax_amount /
                              childOrder.pricing?.currency_factor || 0}{" "}
                            {childOrder.pricing?.symbol_currency}
                          </div>
                          {childOrder.pricing.tip_amount > 0 && (
                            <div>
                              الإكرامية:{" "}
                              {childOrder.pricing.tip_amount /
                                childOrder.pricing?.currency_factor || 0}{" "}
                              {childOrder.pricing?.symbol_currency}
                            </div>
                          )}
                        </td>
                      </tr>
                    )}
                  </tfoot>
                </table>
              </div>

              {/* Store Action History */}
              <StoreActionHistory storeData={childOrder} />

              {/* Divider between stores */}
              {index < children.length - 1 && <hr className="my-4" />}
            </div>
          ))}
        </div>

        {/* Overall Summary */}
        {children.length > 1 && (
          <div className="mt-4 p-3 bg-light rounded-3 border">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="fw-bold text-dark mb-1">
                  إجمالي جميع المتاجر (الإجمالي النهائي للطلب)
                </h6>
                <div className="text-muted small">
                  شامل جميع المتاجر في الطلب
                </div>
              </div>
              <div className="text-end">
                <div className="fw-bold fs-5 text-success">
                  {order.pricing?.final_amount /
                    order.pricing?.currency_factor || 0}{" "}
                  {order.pricing?.symbol_currency || "SYP"}
                </div>
              </div>
            </div>
            {order.pricing?.refunded_amount > 0 && (
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="fw-bold text-danger mb-1"> المبلغ المسترد</h6>
                  <div className="text-muted small">
                    إجمالي المبلغ المسترد من جميع المتاجر
                  </div>
                </div>
                <div className="text-end">
                  <div className="fw-bold fs-5 text-danger ">
                    {order.pricing?.refunded_amount /
                      order.pricing?.currency_factor || 0}{" "}
                    {order.pricing?.symbol_currency || "SYP"}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  ) : null;
};

export default MultiStoreOrder;
